import React, { useState } from "react";
import './TrainStat.css';
import StatIncrement from "./StatIncrement";
import { usePlayerStore } from "../../store/store";
import DraggableModal from '../Modal/DraggableModal';

function TrainStat({ displayModal, sendMessage }) {
    const intitalValues = {
        strength: 0,
        agility: 0,
        toughness: 0,
        intelligence: 0,
        wisdom: 0,
        charisma: 0,
    };

    // Stat descriptions for tooltips
    const statDescriptions = {
        Strength: "Increases melee damage and parry effectiveness.",
        Agility: "Speeds up your stamina recovery and cast times. It also affects various skills, like increasing your dodge chance.",
        Toughness: "Increases health and health regeneration.",
        Wisdom: "Increases mana and mana regeneration.",
        Intelligence: "Increases spell damage.",
        Charisma: "Increases buff and healing effectiveness."
    };

    const playerStats = usePlayerStore((state) => state.playerStats);
    const statPoints = usePlayerStore((state) => state.statPoints);

    const [trainStats, setTrainStats] = useState(intitalValues);

    const increaseStat = (name) => {
        const totalTrainStats = Object.values(trainStats).reduce((a, b) => a + b, 0);

        if (totalTrainStats < statPoints) {
            setTrainStats(prevStats => ({ ...prevStats, [name.toLowerCase()]: prevStats[name.toLowerCase()] + 1 }));
        }
    }


    const decreaseStat = (name) => {
        if (trainStats[name.toLowerCase()] > 0) {
            setTrainStats(prevStats => ({ ...prevStats, [name.toLowerCase()]: prevStats[name.toLowerCase()] - 1 }));
        }
    }

    const reset = () => {
        setTrainStats(intitalValues);
    }

    const confirmStats = () => {

        sendMessage('604'
            + trainStats.strength + ";"
            + trainStats.agility + ";"
            + trainStats.toughness + ";"
            + trainStats.wisdom + ";"
            + trainStats.intelligence + ";"
            + trainStats.charisma + ";");
        reset();
    }

    // Calculate remaining points
    const availablePoints = statPoints - Object.values(trainStats).reduce((a, b) => a + b, 0);

    // A component for the stat name with info icon
    const StatNameWithInfo = ({ name }) => (
        <div className="stat-name-with-info">
            <span>{name}</span>
            <div className="stat-info-icon" tabIndex="0">
                i
                <div className="tooltip-container">
                    <div className="tooltip-content">{statDescriptions[name]}</div>
                </div>
            </div>
        </div>
    );

    return (
        <DraggableModal modalId="trainstats" onClose={displayModal}>
            <div className="tmodal-content">
                <div className="tmodal-header">
                    <span className="close" onClick={displayModal}>&times;</span>
                    <h2>Train Stats</h2>
                </div>
                <div className="stat-points-container">
                    <div className="stat-points-header">
                        <span className="stat-points-title">Available Stat Points</span>
                        <span className="stat-points-value">{availablePoints}</span>
                    </div>
                </div>
                <div className="tmodal-body train-stat-body">
                    <StatIncrement 
                        name={<StatNameWithInfo name="Strength" />}
                        value={playerStats.str} 
                        increase={trainStats.strength} 
                        increaseStat={() => increaseStat("Strength")} 
                        decreaseStat={() => decreaseStat("Strength")}
                        remainingPoints={availablePoints}
                    />
                    <StatIncrement 
                        name={<StatNameWithInfo name="Agility" />}
                        value={playerStats.agi} 
                        increase={trainStats.agility} 
                        increaseStat={() => increaseStat("Agility")} 
                        decreaseStat={() => decreaseStat("Agility")}
                        remainingPoints={availablePoints}
                    />
                    <StatIncrement 
                        name={<StatNameWithInfo name="Toughness" />}
                        value={playerStats.tog} 
                        increase={trainStats.toughness} 
                        increaseStat={() => increaseStat("Toughness")} 
                        decreaseStat={() => decreaseStat("Toughness")}
                        remainingPoints={availablePoints}
                    />
                    <StatIncrement 
                        name={<StatNameWithInfo name="Wisdom" />}
                        value={playerStats.wis} 
                        increase={trainStats.wisdom} 
                        increaseStat={() => increaseStat("Wisdom")} 
                        decreaseStat={() => decreaseStat("Wisdom")}
                        remainingPoints={availablePoints}
                    />
                    <StatIncrement 
                        name={<StatNameWithInfo name="Intelligence" />}
                        value={playerStats.intel} 
                        increase={trainStats.intelligence} 
                        increaseStat={() => increaseStat("Intelligence")} 
                        decreaseStat={() => decreaseStat("Intelligence")}
                        remainingPoints={availablePoints}
                    />
                    <StatIncrement 
                        name={<StatNameWithInfo name="Charisma" />}
                        value={playerStats.chr} 
                        increase={trainStats.charisma} 
                        increaseStat={() => increaseStat("Charisma")} 
                        decreaseStat={() => decreaseStat("Charisma")}
                        remainingPoints={availablePoints}
                    />
                </div>

                <div className="tmodal-footer">
                    <button className="ts-close" onClick={displayModal}>Close</button>
                    <button className="ts-button" onClick={reset}>Reset</button>
                    <button className="ts-button" onClick={confirmStats}>Confirm</button>
                </div>

            </div>
        </DraggableModal>
    );
}


export default TrainStat;